import { apiClient } from "../../../client";
import { Filter, StandardAxiosConfig, getBaseDataURL } from "../../../common";
import { CreateOperatorInput, TeamMember } from "@domain/CRM/teamMember";
import { DataAPI_Base } from "../base";

/** Active team members without a login password — the set-password candidates. */
export const ACTIVE_PASSWORDLESS_MEMBERS_FILTER: Filter<TeamMember> = {
	type: "AND",
	fields: [{ status: "Active" }, { password: { operator: "is_empty" } }],
};

export class TeamMembersAPI extends DataAPI_Base<TeamMember> {
	constructor() {
		super("team-members", TeamMember);
	}

	async setPassword(teamMemberId: string, password: string): Promise<TeamMember> {
		const url = `${getBaseDataURL("team-members")}/set-password`;
		const response = await apiClient.post(url, { team_member_id: teamMemberId, password }, StandardAxiosConfig());
		return response.data as TeamMember;
	}

	async createOperator(input: CreateOperatorInput): Promise<TeamMember> {
		const url = `${getBaseDataURL("team-members")}/create`;
		// Backend CreateTeamMemberRequest uses camelCase aliases (ModifiedBaseModel),
		// so the CreateOperatorInput can be posted as-is.
		const response = await apiClient.post(url, input, StandardAxiosConfig());
		return response.data as TeamMember;
	}
}
